// Wrappers so jsdom 26 tests can stub navigation without mutating window.location.
export const replaceLocation = (url: string): void => {
  window.location.replace(url);
};

export const reloadPage = (): void => {
  window.location.reload();
};

export const closeWindow = (): void => {
  window.close();
};
